import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import VerdictHistory from './VerdictHistory';

interface VerdictHistoryModalProps {
	open: boolean;
	onClose: () => void;
	courseMappingHeadId: number;
	title?: string;
}

const VerdictHistoryModal: React.FC<VerdictHistoryModalProps> = ({
	open,
	onClose,
	courseMappingHeadId,
	title = 'Verdict History'
}) => {
	return (
		<Dialog 
			open={open} 
			onClose={onClose}
			maxWidth="lg"
			fullWidth
		>
			<DialogTitle>{title}</DialogTitle>
			<DialogContent>
				<VerdictHistory
					courseMappingHeadId={courseMappingHeadId}
					verdict={null}
					setVerdict={() => {}}
					height="500px"
					readonly={true}
				/>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose} color="primary">
					Close
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default VerdictHistoryModal;